module.exports = __webpack_public_path__ + "img/mobile_brand.c9c59e0f.png";